import { performance } from 'node:perf_hooks';
import crypto from 'node:crypto';
import { setTimeout } from 'node:timers';

export function formatDate(date: Date, fmt: string = 'yyyy-MM-dd hh:mm:ss'): string {
  const replacements: Record<string, number> = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  };

  // Handle year replacement with modern regex approach
  const yearMatch = fmt.match(/(y+)/);
  if (yearMatch) {
    const yearPattern = yearMatch[1];
    const yearStr = date.getFullYear().toString();
    const replacement = yearStr.substring(4 - yearPattern.length);
    fmt = fmt.replace(yearPattern, replacement);
  }

  // Handle other replacements
  for (const [pattern, value] of Object.entries(replacements)) {
    const regex = new RegExp(`(${pattern})`);
    const match = fmt.match(regex);
    if (match) {
      const matchedPattern = match[1];
      const replacement = matchedPattern.length === 1 
        ? value.toString() 
        : value.toString().padStart(2, '0');
      fmt = fmt.replace(matchedPattern, replacement);
    }
  }
  
  return fmt;
}

export function generateUUID(): string {
  // Use crypto.randomUUID if available (modern browsers and Node.js 14.17+)
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  
  // Fallback to manual generation
  let d = new Date().getTime();
  let d2 = (typeof performance !== 'undefined' && performance.now && (performance.now() * 1000)) || 0;
  
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    let r = Math.random() * 16;
    if (d > 0) {
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}

export function sleep(millisecond: number) {
  return new Promise<void>(resolve => {
    setTimeout(() => {
      resolve();
    }, millisecond);
  });
}

export function isBrowser(): boolean {
  return typeof window !== 'undefined';
}
